import Vue from 'vue';
import Router from 'vue-router';
import Hello from '@/components/Hello';
import Game from '@/components/Game';
import Rules from '@/components/Rules';
import GoodLuck from '@/components/GoodLuck';
import Session from '@/components/Session';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
    },
    {
      path: '/game',
      name: 'Game',
      component: Game,
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules,
    },
    {
      path: '/goodluck',
      name: 'GoodLuck',
      component: GoodLuck,
    },
    {
      path: '/session',
      name: 'Session',
      component: Session,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js